import { render, staticRenderFns } from "./PageAdPlacements.vue?vue&type=template&id=54a5c3aa&"
import script from "./PageAdPlacements.vue?vue&type=script&lang=js&"
export * from "./PageAdPlacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a5c3aa')) {
      api.createRecord('54a5c3aa', component.options)
    } else {
      api.reload('54a5c3aa', component.options)
    }
    module.hot.accept("./PageAdPlacements.vue?vue&type=template&id=54a5c3aa&", function () {
      api.rerender('54a5c3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AdPlacements/PageAdPlacements.vue"
export default component.exports